module.exports = __webpack_public_path__ + "static/media/pocker.0b8b9af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/pocker.png
// module id = 2402
// module chunks = 7